import moment from "moment";
import NumeroALetras from "../../../../componentes/funciones/NumeroALetras";
import { generarPDF } from "../../../../componentes/imprimir/GenerarPDF";
import { ImprimirEnIframe } from "../../../../componentes/imprimir/ImprimirEnIframe";
import { NegocioConfig } from "../../../../configuracion/Empresa";
import { formatoMoneda, formatoNumero } from "../../../../configuracion/validaciones";

export const ImprimirCompra = (compra) => {
  if (!compra) return;

  const {
    numeroFactura,
    proveedor,
    Empleado,
    compraDetalles = [],
    totalCompra = 0,
    pagoCompras: pagocompras = [],
  } = compra;

  const pagosCompletados = pagocompras?.map(pc => pc.pago).filter(p => p && p.estado !== 'Anulada') || [];
  const pago = pagosCompletados[pagosCompletados.length - 1] || {};

  const fechaHora = moment(pago.fecha || new Date()).format("DD-MM-YYYY HH:mm:ss");
  const recibido = parseFloat(pago.recibido || 0);
  const cambio = Math.max(recibido - parseFloat(totalCompra), 0);

  const efectivo =
    pago.pagoefectivos?.reduce((sum, p) => sum + parseFloat(p.monto || 0), 0) || 0;
  const transferencia =
    pago.pagotransferencia?.reduce((sum, p) => sum + parseFloat(p.monto || 0), 0) || 0;
  const tarjeta =
    pago.pagotarjeta?.reduce((sum, p) => sum + parseFloat(p.monto || 0), 0) || 0;

  const numeroDocumento = formatoNumero(numeroFactura) || String(compra?.id || "—");

  const subtotalBruto = compraDetalles.reduce((total, item) => {
    const cantidad = parseFloat(item.cantidad || 0);
    const costo = parseFloat(item.costo || 0);
    return total + cantidad * costo;
  }, 0);

  const logoSrc = NegocioConfig.logo;

  const html = `
      <div style="width:280px; font-family:'Arial', sans-serif; font-size:14px; color:black; padding:0; margin:0;">
          <img src="${logoSrc}" style="width:150px; height:100px; display:block; margin:0 auto; padding:0; border:0;" alt="Logo" />
        <div style="text-align:center; margin-bottom:5px;">
          <div style="font-weight:bold; font-size:16px;">${NegocioConfig.nombre}</div>
          <div style={{ fontSize: 12 }}>
            RTN: ${NegocioConfig.rtn}
          </div>
          <div style={{ fontSize: 12 }}>
            ${NegocioConfig.direccion}
          </div>
          <div style={{ fontSize: 12 }}>
            Tel: ${NegocioConfig.telefono}
          </div>
        <div style="font-weight:bold; margin:5px 0; text-align: left;">COMPROBANTE DE COMPRA No. ${numeroDocumento}</div>
        <div style="text-align: left;"><span>Fecha:</span> ${fechaHora}</div>
        <div style="text-align: left;"><span>Atendió:</span> ${Empleado?.nombreCompleto || "—"}</div>
      </div>
      <hr style="border:1px dashed black;" />
        <div><strong>Proveedor:</strong>${proveedor?.nombre || 'N/A'}</div>
        <div><strong>RTN:</strong> ${proveedor?.rtn || 'N/A'}</div> 
        <hr style="border:1px dashed black;" />
        <div style="margin-top:5px;">
          ${compraDetalles.map((item) => {
            const nombre = item.producto?.nombre || "—";
            const cantidad = parseFloat(item.cantidad || 0);
            const costo = parseFloat(item.costo || 0);
            const subtotalItem = cantidad * costo;
            return `
              <div style="margin-bottom:5px;">
                <div style="font-weight:bold;">${nombre}</div>
                <div style="display:flex; justify-content:space-between;">
                  <span>${cantidad} x ${formatoMoneda(costo)}</span>
                  <span>${formatoMoneda(subtotalItem)}</span>
                </div>
              </div>`;
          }).join("")}
        </div>
        <hr style="border:1px dashed black;" />
        <div style="text-align:right;">
          <div>Subtotal Ítems: <strong>${formatoMoneda(subtotalBruto)}</strong></div>
          <div>Descuento: <strong>${formatoMoneda(0)}</strong></div>
          <div style="font-size:14px; font-weight:bold;">Total: ${formatoMoneda(totalCompra)}</div>
          <div style="margin-top:4px; margin-bottom:8px; font-weight:bold; font-size:12px; text-transform:uppercase;">
            ${NumeroALetras(totalCompra)}
          </div>
          <div>Total Pagado: <strong>${formatoMoneda(recibido)}</strong></div>
          ${efectivo > 0 ? `<div>Efectivo: <strong>${formatoMoneda(efectivo)}</strong></div>` : ""}
          ${tarjeta > 0 ? `<div>Tarjeta: <strong>${formatoMoneda(tarjeta)}</strong></div>` : ""}
          ${transferencia > 0 ? `<div>Transferencia: <strong>${formatoMoneda(transferencia)}</strong></div>` : ""}
          <div style="font-size:14px; font-weight:bold;">Cambio: ${formatoMoneda(cambio)}</div>
        </div>
        <div style="text-align:center; margin-top:20px; font-size:14px;">
        ${pago.documento !== "CR"
    ? "<strong>¡Gracias por su compra!</strong>"
    : "<strong>Gracias por su preferencia.</strong>"}
        </div>
      </div>
    `;

  ImprimirEnIframe(html, `Comprobante de Compra ${numeroDocumento}`, '5px');
  const nombrePDF = `Comprobante_Compra_${numeroDocumento}.pdf`;
  generarPDF(html, nombrePDF, 88);
};